// src/voip/dtmfTone.js

// Standard DTMF frequency pairs
const DTMF_FREQUENCIES = {
  1: [697, 1209],
  2: [697, 1336],
  3: [697, 1477],
  4: [770, 1209],
  5: [770, 1336],
  6: [770, 1477],
  7: [852, 1209],
  8: [852, 1336],
  9: [852, 1477],
  '*': [941, 1209],
  0: [941, 1336],
  '#': [941, 1477],
};

let audioCtx;
export default function playLocalDTMFTone(digit, duration = 150) {
  const freqs = DTMF_FREQUENCIES[digit];
  if (!freqs) return;

  audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();

  const [f1, f2] = freqs;
  const osc1 = audioCtx.createOscillator();
  const osc2 = audioCtx.createOscillator();
  const gain = audioCtx.createGain();

  osc1.type = 'sine';
  osc2.type = 'sine';
  osc1.frequency.value = f1;
  osc2.frequency.value = f2;
  gain.gain.value = 0.1;

  osc1.connect(gain);
  osc2.connect(gain);
  gain.connect(audioCtx.destination);

  osc1.start();
  osc2.start();

  setTimeout(() => {
    osc1.stop();
    osc2.stop();
    osc1.disconnect();
    osc2.disconnect();
    gain.disconnect();
  }, duration);
}
